import { useCallback, useEffect } from 'react';

import { Formik, Form } from 'formik';

import { useHistory, Link } from 'react-router-dom';
import { cnpj, cpf } from 'cpf-cnpj-validator';

import { useDispatch } from 'react-redux';

import ButtonBack from '../../components/ButtonBack'
import Input from '../../components/Form/Input'
import { Container, SectionRegister } from './styles'

import formSchema from '../../utils/schemas/document';
import ErrorMessage from '../../components/Form/ErrorMessage';
import Button from '../../components/Button';
import Text from '../../components/Text';

import { setCredential } from '../../redux/ducks/main';
import { FormGroup, Label } from '../../components/Form';
import { userExists } from '../../services/user';
import { resetEmails } from '../../redux/ducks/emails';

export default function DocumentPage() {

  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetEmails());
  }, [dispatch]);

  const onSubmit = useCallback(async (data, { setSubmitting, isSubmitting }) => {
    if (isSubmitting) {
      return;
    }
    setSubmitting(true);

    if (cpf.isValid(data.document) || cnpj.isValid(data.document)) {
      history.push('login/emails', {
        document: data.document.replace(/[^0-9]+/g, '')
      });
    } else {
      dispatch(setCredential(data.document));
      try {
        await userExists({ email: data.document });
        history.push('login/form');
      } catch (err) {
        history.push('/register', { email: data.document });
      }
    }
    setSubmitting(false);
  }, [history, dispatch])

  return (
    <>
      <ButtonBack href="https://www.zonasul.com.br" />
      <Container>
        <Text text="Identificação" variant="title1" align="center" />
        <Formik initialValues={{ document: '' }} validateOnMount validationSchema={formSchema} onSubmit={onSubmit}>
          {({ isSubmitting, isValid }) => (
            <Form className="login__form form">
              <FormGroup>
                <Label htmlFor="cpf">Informe seu CPF/CNPJ ou e-mail</Label>
                <Input type="text" name="document" formater="documentOrEmail" className="form__input"  autoComplete="off">
                  {!isSubmitting && <button className="login__btn login__btn--smaller" disabled={!isValid} type="submit">OK</button>}
                </Input>
                <ErrorMessage name="document" />
               
              </FormGroup>
              <Button variant="buttonPrimary" type="submit" text="Continue" loading={isSubmitting} disabled={!isValid} />
              <SectionRegister>
                <p>Ainda não possui cadastro?</p>
                <Link to="/register" className="no-login__link">Cadastre-se</Link>
              </SectionRegister>
            </Form>
          )}
        </Formik>
      </Container>
    </>
  )
}

